import React, { useState } from "react";
import { Colors } from "../../config";
import styled from "styled-components";
import Typography from "./Typography";
import { getInitials } from "../../helper";
import StatusChip from "./StatusChip";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const hasTrip = true;
let approvers = ["Jasim", "Sahana", "Deybi"];

const UpcomingLeaves = ({
  onCancelLeave,
  data,
  onLeaveSelect,
  onLoadApprovers,
  approversList,
}) => {
  const [activeIndex, setActiveIndex] = useState("");
  const navigate = useNavigate();
  return (
    <>
      <SideContentHeader>
        <div>Business Trip Leave Details</div>
      </SideContentHeader>
      {data?.map((val, index) => (
        <ContentWrapper onClick={() => onLeaveSelect(val)}>
          <StyledCard>
            <div style={{ padding: "8px" }}>
              <InfoWrapper>
                <InfoBlock>
                  <Label>Start Date</Label>
                  <Value>
                    {dayjs(parseInt(val.startDate.match(/(\d+)/)[0])).format(
                      "DD MMM YYYY",
                    )}
                  </Value>
                </InfoBlock>
                <InfoBlock>
                  <Label>Expected Return Date</Label>
                  <Value>
                    {dayjs(
                      parseInt(val.loaExpectedReturnDate.match(/(\d+)/)[0]),
                    ).format("DD MMM YYYY")}
                  </Value>
                </InfoBlock>
                <InfoBlock align="right">
                  <Label>Status</Label>
                  <Value>
                    <StatusChip
                      color={Colors.brandTwo}
                      label={val.approvalStatus.replaceAll("_", " ")}
                    />
                  </Value>
                </InfoBlock>
                <ArrowWrapper
                  onClick={() => {
                    let newIndex = activeIndex === index ? "" : index;
                    setActiveIndex(newIndex);
                    if (
                      newIndex !== "" &&
                      val?.approvalStatus?.toLowerCase() !== "approved"
                    ) {
                      onLoadApprovers(
                        val?.approvalStatus?.toLowerCase() ===
                          "pending_cancellation"
                          ? val?.cancellationWorkflowRequestId
                          : val?.workflowRequestId,
                      );
                    }
                  }}
                >
                  <img
                    style={{ width: "24px" }}
                    src={require("../../assets/images/biz_booking_arrow_circle.png")}
                    alt="arrow"
                  />
                </ArrowWrapper>
              </InfoWrapper>
            </div>
            {activeIndex === index && (
              <>
                <div style={{ padding: "8px", boxSizing: "border-box" }}>
                  <InfoWrapper>
                    <InfoBlock width="70%">
                      <Label>Purpose of Travel</Label>
                      <Value>{val.comment}</Value>
                    </InfoBlock>
                    <InfoBlock width="26%" align="right">
                      <Label>Action</Label>
                      <Value>
                        <div
                          style={{
                            color: Colors.brandOne,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(
                              `/user/bookings/status/${val.externalCode}`,
                            )
                          }
                        >
                          View Trip Details
                        </div>
                      </Value>
                    </InfoBlock>
                  </InfoWrapper>
                </div>
                {/* val?.approvalStatus?.toLowerCase() !== 'approved' */}
                {val?.approvalStatus?.toLowerCase() !== "approved" && (
                  <>
                    {val?.workflowRequestId === approversList?.id ||
                    val?.cancellationWorkflowRequestId === approversList?.id ? (
                      <>
                        <div
                          style={{
                            padding: "0.5rem 0",
                            marginTop: "0.5rem",
                            background: "#EBEEF3",
                          }}
                        >
                          <Typography fontSize={"14px"}>
                            Approval History
                          </Typography>
                        </div>
                        <div
                          style={{
                            padding: "0.5rem 0",
                            background: "#D9D9D9",
                            display: "flex",
                            padding: "8px",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            fontSize={"13px"}
                            fontColor={Colors.black}
                          >
                            Approvers
                          </Typography>
                          <Typography
                            fontSize={"13px"}
                            fontColor={Colors.black}
                          >
                            Status
                          </Typography>
                        </div>
                        {approversList?.approvers?.map((approver, idx) => (
                          <>
                            <div
                              style={{
                                display: "flex",
                                gap: "0.5rem",
                                padding: "1rem",
                              }}
                            >
                              <div>{idx + 1}.</div>
                              <div
                                style={{
                                  color: Colors.white,
                                  height: "36px",
                                  width: "36px",
                                  background: Colors.brandTwo,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "36px",
                                  margin: "0 4px",
                                }}
                              >
                                {getInitials(approver?.displayName)}
                              </div>
                              <div
                                style={{
                                  flex: 1,
                                  display: "flex",
                                  justifyContent: "space-between",
                                  textAlign: "left",
                                  gap: "0.5rem",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.25rem",
                                  }}
                                >
                                  <Typography
                                    fontSize={"16px"}
                                    fontColor={Colors.black}
                                  >
                                    {approver?.displayName}
                                  </Typography>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ width: "12px" }}
                                      src={require("../../assets/images/biz_approver_user.png")}
                                      alt="arrow"
                                    />
                                    <Typography
                                      fontSize={"11px"}
                                      fontColor={Colors.gray}
                                    >
                                      {approver?.email}
                                    </Typography>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ width: "12px" }}
                                      src={require("../../assets/images/biz_approver_title.png")}
                                      alt="arrow"
                                    />

                                    <Typography
                                      fontSize={"11px"}
                                      fontColor={Colors.gray}
                                    >
                                      Level {idx + 1}
                                    </Typography>
                                  </div>
                                  {/* <div style={{ marginTop: "0.5rem" }}>
                                    <Typography
                                      fontSize={"13px"}
                                      fontColor={Colors.gray}
                                    >
                                      Comments
                                    </Typography>
                                    <Typography
                                      fontSize={"12px"}
                                      fontColor={Colors.black}
                                    >
                                                                            {val?.comment}

                                    </Typography>
                                  </div> */}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.25rem",
                                    textAlign: "right",
                                  }}
                                >
                                  <Typography
                                    fontSize={"14px"}
                                    fontColor={
                                      approversList?.currentStepNum > idx + 1
                                        ? Colors.greenHaze
                                        : Colors.goldenYellow
                                    }
                                  >
                                    {approversList?.currentStepNum > idx + 1
                                      ? "Approved"
                                      : "Pending"}
                                  </Typography>
                                  {/* <Typography
                            fontSize={"13px"}
                            fontColor={Colors.black}
                          >
                            05:30 PM, 28 Mar 2024
                          </Typography> */}
                                </div>
                              </div>
                            </div>
                            {approvers.length !== idx + 1 && (
                              <div
                                style={{
                                  background: Colors.lightAshOpacity10,
                                  height: "12px",
                                }}
                              ></div>
                            )}
                          </>
                        ))}
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          padding: "1rem",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: Colors.brandTwo,
                        }}
                      >
                        Loading Approval History...
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </StyledCard>
        </ContentWrapper>
      ))}
    </>
  );
};

// Styled components

const SideContentHeader = styled.div`
  margin-top: 1.5rem;
  font-size: 1.1rem;
  color: ${Colors.white};
  display: flex;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem;
`;

const StyledCard = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  // padding: 8px;
  width: 100%;
  box-sizing: border-box;
`;

const StyledTitle = styled.div`
  font-size: 1.25rem;
  color: ${Colors.prussianBlue};
  font-weight: 600;
  text-align: left;
  margin-bottom: 8px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 0.9rem;
`;

const InfoBlock = styled.div`
  width: ${(props) => (props.width ? props.width : "32%")};
  padding: 8px;
  box-sizing: border-box;
  text-align: ${(props) => (props.align ? props.align : "left")};
  display: flex;
  align-items: ${(props) =>
    props.align ? (props.align === "right" ? "end" : "start") : "start"};
  flex-direction: column;
`;

const Label = styled.div`
  color: ${Colors.gullGray};
  margin-bottom: 4px;
  font-weight: 500;
`;

const Value = styled.div`
  color: ${Colors.black};
  font-weight: 500;
`;

const ArrowWrapper = styled.div`
  width: 4%;
  padding: 8px 0;
  box-sizing: border-box;
  text-align: right;
`;

export default UpcomingLeaves;
